'use strict';

module.exports = locate;

function locate(value, fromIndex) {
  return value.indexOf('<', fromIndex);
}



// WEBPACK FOOTER //
// /Users/jinxuanzhu/.nvm/versions/node/v8.4.0/lib/node_modules/remark-parse/lib/locate/tag.js